
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import LearnMore from "@/components/common/LearnMore.vue";
import Faq from "@/components/common/FAQ.vue";
import { IBreadCrumbRoute } from "@/types/index";
import FixedRouteServContent from "@/components/transService/FixedRouteServContent.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import ContactusContent from "@/components/contact/ContactusContent.vue";

export default Vue.extend({
  name: "FixedRouteServices",
  components: {
    Faq,
    HeroBanner,
    BreadCrumb,
    LearnMore,
    FixedRouteServContent,
    ContactusContent,
  },
  mixins: [UIFeatureMixin],
  data() {
    return {
      routes: [
        {
          to: { name: "home" },
          text: "Home",
        },
        {
          to: { name: "transServicesOverview" },
          text: "Transportation Services",
        },
        {
          to: { name: "fixedRouteServices" },
          text: "Fixed Route Services",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "FRS_HERO_C,FRS_CONTEN,FRS_LEARN,FRS_HEADER,FRS_C_S2A,FRS_C_S2B,FRS_C_S3A,FRS_C_S3B,FRS_FAQS,TRS_FRT,FXD_RT_SRV,FRS_CNTCT,HME_THIS,NCOUNTY_1,NCOUNTY_2,NCOUNTY_3,AVAIL_CNTY,AVL_COUNTY,QUICK_SRCH,ER_INLINE,CHGLGN_TXT,ADMN_USR,MAIN,MAIN_TITLE,FMR,ENVRONMNT,ADA,FTP,MATP,PWD,SSR,CNTCT_US,CNT_US_C,SEL_CNTY,FLT_CNTIES,FRS_TRAING"
    );
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
